import Terms from "../page/Terms/Terms"
import Assets from "../page/Assets/Assets"
import PurchaseActiveIcon from "../images/PurchasesActiveIcon"
import PurchaseIcon from "../images/PurchaseIcon"
import SaleLedgerActiveIcon from "../images/SaleLedgerActiveIcon"
import SaleLedgerIcon from "../images/SaleLedgerIcon"
import PurchaseLedger from "../page/History/PurchaseLedger"
import SalesLedger from "../page/History/SalesLedger"

const HistorySideBar = [
    {
        index: 1,
        name: "Purchase Ledger",
        show: true,
        showRoute: true,
        path: "/purchaseLedger",
        component: PurchaseLedger,
        image: PurchaseIcon,
        imageActive: PurchaseActiveIcon
    },
    {
        index: 2,
        name: "Sales Ledger",
        show: true,
        showRoute: true,
        path: "/salesLedger",
        component: SalesLedger,
        image: SaleLedgerIcon,
        imageActive: SaleLedgerActiveIcon
    },
]
export default HistorySideBar